<template>
  <div>
    <page-header :title="$t('bill.text_285')" />
    <page-body>
      <exchange-rate-list :id="listId" />
    </page-body>
  </div>
</template>

<script>
import ExchangeRateList from './components/List'

export default {
  name: 'BillExchangeRateIndex',
  components: {
    ExchangeRateList,
  },
  data () {
    return {
      listId: 'BillExchangeRateList',
    }
  },
}
</script>
